import { useContext, type FC } from 'react';
import type { MarketHistoryProps } from './types';
import { Widget } from '../../widget';
import TokenSelector from '../../token-selector';
import Source from '../../source';
import WidgetButtons from '../../widget-buttons';
import { CurrencyTypeEnum, VolSurfaceToken } from '../../../../model/currency_type.enum';
import { MarketHistoryContent } from './market-history-content';
import { ChartTypeEnum } from '../../../../model/chart_type.enum';
import { MarketDataContext } from '../../../../providers/market-data/market-data-provider';

const MarketHistoryWidget: FC<MarketHistoryProps> = (props) => {
  const {
    widget,
    actions,
    permissions = { canChangeToken: true, canDelete: true, canDuplicate: true },
  } = props;
  const context = useContext(MarketDataContext);
  const controlledToken = props.currentToken ?? context.token;
  const handleSetToken = (t: VolSurfaceToken) => {
    if (props.onChangeToken) return props.onChangeToken(t as CurrencyTypeEnum);
    context.setToken(t as CurrencyTypeEnum);
  };

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          <TokenSelector
            token={controlledToken as CurrencyTypeEnum}
            setToken={handleSetToken}
            isFixedToken={!permissions.canChangeToken}
          />
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <MarketHistoryContent keyParam={controlledToken} chartType={ChartTypeEnum.Area} />
      </Widget.Content>
      <Widget.Footer>
        <div className="footer-content">
          <Source source="Deribit" url="https://www.deribit.com" />
        </div>
      </Widget.Footer>
    </Widget>
  );
};

export default MarketHistoryWidget;
